import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpRequest, HttpHandler, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap, map } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';

@Injectable()
export class APInterceptor implements HttpInterceptor {
    private errorShown = false;
    // ISO 8601 date regex pattern
    private iso8601 = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:\d{2})?$/;

    constructor(private toaster: MessageService, private router: Router) { }

    intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const handle = next.handle(
            localStorage.getItem('Token')
                ? httpRequest.clone({
                    setHeaders: {
                        "Authorization": localStorage.getItem('TokenType') + " " + localStorage.getItem('Token')
                    }
                })
                : httpRequest
        );

        return handle.pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse && httpRequest.method === 'GET') {
                    return event.clone({ body: this.convertDates(event.body) });
                }
                return event;
            }),
            catchError(error => this.handleError(error))
        );
    }

    private convertDates(body: any): any {
        if (body === null || body === undefined) {
            return body;
        }

        if (typeof body !== 'object') {
            return body;
        }

        for (const key of Object.keys(body)) {
            const value = body[key];

            if (typeof value === 'string' && this.iso8601.test(value)) {
                // Parse UTC date and convert to local timezone
                const utcDate = new Date(value);
                body[key] = new Date(utcDate.getTime() - utcDate.getTimezoneOffset() * 60000);
            } else if (typeof value === 'object') {
                this.convertDates(value);
            }
        }

        return body;
    }

    private handleError(error: HttpErrorResponse) {
        switch (error.status) {
            case 403:
            case 401:
                if (!this.errorShown) {
                    this.toaster.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: "UnAuthorized Request",
                        styleClass: 'danger-background-popover',
                    });
                } else {
                    this.errorShown = true;
                }
                this.router.navigate(['/login']);
                break;
            case 404:
            case 409:
                let message = error.error || 'Something went wrong. Please try again later';
                this.toaster.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: message,
                    styleClass: 'danger-background-popover',
                });
                break;
            case 422:
                Object.getOwnPropertyNames(error.error).forEach(m => {
                    this.toaster.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error.error[m],
                        styleClass: 'danger-background-popover',
                    });
                });
                break;
            case 500:
            default:
                this.toaster.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Something went wrong. Please try again later',
                    styleClass: 'danger-background-popover',
                });
                break;
        }
        return throwError(error);
    }
}


